<ebw-monorepo-sidebar-header
  [icon]="'hardware'"
  [title]="'map.sidebar.analisi_schiacciamenti.title'"
  [isSvg]="false"
  [isOutline]="false"
>
{{'map.sidebar.analisi_schiacciamenti.info_section' | translate}}
</ebw-monorepo-sidebar-header>
<div class="d-flex flex-column gap-3">
  <form [formGroup]="form" class="d-flex flex-column gap-4">
    <!-- SEGMENTO 1 -->
    <mat-form-field appearance="outline" [ngClass]="{'mb-4': form.get('segmento1')?.invalid && form.get('segmento1')?.touched }">
      <mat-label>Campo 1</mat-label>
      <input
        type="text"
        matInput
        formControlName="segmento1"
        [matAutocomplete]="autoCampo1"
        [placeholder]="'map.sidebar.analisi_schiacciamenti.input_placeholder' | translate"
      />
      <mat-autocomplete #autoCampo1="matAutocomplete">
        <mat-option *ngFor="let result of searchResultsCampo1" [value]="result.desc" (click)="onItemSelect(result.desc, 'segmento1')">
          {{ result.desc }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('segmento1').hasError('optionError')">
        <ng-container *ngTemplateOutlet="errorOption"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento1').hasError('required')">
        <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento1').hasError('solrError')">
        <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
      </mat-error>
    </mat-form-field>

    <!-- SEGMENTO 2 -->
    <mat-form-field appearance="outline" [ngClass]="{'mb-4': form.get('segmento2')?.invalid && form.get('segmento2')?.touched }">
      <mat-label>Campo 2</mat-label>
      <input
        type="text"
        matInput
        formControlName="segmento2"
        [matAutocomplete]="autoCampo2"
        [placeholder]="'map.sidebar.analisi_schiacciamenti.input_placeholder' | translate"
      />
      <mat-autocomplete #autoCampo2="matAutocomplete">
        <mat-option *ngFor="let result of searchResultsCampo2" [value]="result.desc" (click)="onItemSelect(result.desc, 'segmento2')">
          {{ result.desc }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('segmento2').hasError('optionError')">
        <ng-container *ngTemplateOutlet="errorOption"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento2').hasError('required')">
        <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento2').hasError('solrError')">
        <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
      </mat-error>
    </mat-form-field>

    <!-- SEGMENTO 3 -->
    <mat-form-field appearance="outline" [ngClass]="{'mb-4': form.get('segmento3')?.invalid && form.get('segmento3')?.touched }">
      <mat-label>Campo 3</mat-label>
      <input
        type="text"
        matInput
        formControlName="segmento3"
        [matAutocomplete]="autoCampo3"
        [placeholder]="'map.sidebar.analisi_schiacciamenti.input_placeholder' | translate"
      />
      <mat-autocomplete #autoCampo3="matAutocomplete">
        <mat-option
          *ngFor="let result of searchResultsCampo3"
          [value]="result.desc"
          (click)="onItemSelect(result.desc, 'segmento3')"
        >
          {{ result.desc }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('segmento3').hasError('optionError')">
        <ng-container *ngTemplateOutlet="errorOption"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento3').hasError('required')">
        <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento3').hasError('solrError')">
        <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
      </mat-error>
    </mat-form-field>
    <!-- SEGMENTO 4 -->
    <mat-form-field appearance="outline" [ngClass]="{'mb-4': form.get('segmento4')?.invalid && form.get('segmento4')?.touched }">
      <mat-label>Campo 4</mat-label>
      <input
        type="text"
        matInput
        formControlName="segmento4"
        [matAutocomplete]="autoCampo4"
        [placeholder]="'map.sidebar.analisi_schiacciamenti.input_placeholder' | translate"
      />
      <mat-autocomplete #autoCampo4="matAutocomplete">
        <mat-option
          *ngFor="let result of searchResultsCampo4"
          [value]="result.desc"
          (click)="onItemSelect(result.desc, 'segmento4')"
        >
          {{ result.desc }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('segmento4').hasError('optionError')">
        <ng-container *ngTemplateOutlet="errorOption"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento4').hasError('required')">
        <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('segmento4').hasError('solrError')">
        <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
      </mat-error>
    </mat-form-field>
  </form>
  <ebw-monorepo-as-footer
    [styleContainer]="'as-btn-container'"
    [buttons]="[{ label: 'map.sidebar.analisi_schiacciamenti.button_label' | translate, type: 'flat' }]"
    (changeComponentHandler)="submitForm()"
  ></ebw-monorepo-as-footer>
</div>

<ng-template #errorRequired>{{ 'map.sidebar.analisi_schiacciamenti.form.error_required' | translate }}</ng-template>
<ng-template #errorSolr>{{ 'map.sidebar.analisi_schiacciamenti.form.error_solr' | translate }}</ng-template>
<ng-template #errorOption>{{ 'map.sidebar.analisi_schiacciamenti.form.error_option' | translate }}</ng-template>
